<div class="projects-card__results-wrap" v-if="projects !== null">
    <div class="row flex-row align-items-stretch">
        <div v-for="(project, index) in projects" class="col-sm-6 col-lg-4 mb-4" data-aos-once="true" data-aos="fade-up" :data-aos-delay="50 * index">
            <workbench-card
                :index="index"
                :baseUrl="pageData.BaseUrl"
                :urlName="project.UrlName"
                :heroImage="project.HeroImage"
                :heroImageAltText="project.HeroImageAltText"
                :ambassadorImage="project.Ambassador.Image"
                :ambassadorImageNormal="project.Ambassador.ImageNormal"
                :ambassadorImageNormalAltText="project.Ambassador.ImageNormalAltText"
                :ambassadorDisplayTitle="project.Ambassador.DisplayTitle"
                :projectTitle="project.Title"
                :projectType="project.ArticleType"
                :difficulty="project.Difficulty"
                :time="project.Time"
                :translations="translations"
            />
        </div>
    </div>
</div>